/**
 * Remembers where the user was before opening Help, and which Help topic they were
 * reading, so the Help button can toggle back and reopen where they left off.
 * sessionStorage only: it is a per-tab convenience, never state that must survive.
 */
const RETURN_KEY = "salesapp:help:return";
const LAST_KEY = "salesapp:help:last";

function read(key: string): string | null {
  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string | null): void {
  try {
    if (value === null) window.sessionStorage.removeItem(key);
    else window.sessionStorage.setItem(key, value);
  } catch {
    /* Storage can be blocked; Help still works without it. */
  }
}

export function isHelpPath(pathname: string): boolean {
  return pathname === "/help" || pathname.startsWith("/help/");
}

export const helpMemory = {
  rememberPage: (path: string) => write(RETURN_KEY, path),
  returnPage: () => read(RETURN_KEY),
  rememberTopic: (search: string) => write(LAST_KEY, search || null),
  /** Query string (with leading "?") of the last Help topic, or "". */
  lastTopic: () => read(LAST_KEY) ?? "",
};
